//#region src/starbucks_merchant_id.ts
var StarbucksMerchantId = /* @__PURE__ */ function(StarbucksMerchantId) {
	StarbucksMerchantId["Starbucks"] = "starbucks-merchant-id";
	StarbucksMerchantId["Kowalskis"] = "97035900006";
	StarbucksMerchantId["VillaGroupJfk"] = "97400802647";
	StarbucksMerchantId["HmsHost"] = "97026601001";
	StarbucksMerchantId["ChapmanUniversity"] = "97400705279";
	StarbucksMerchantId["FloridaStateUniversity"] = "97400705311";
	return StarbucksMerchantId;
}(StarbucksMerchantId || {});
//#endregion
export { StarbucksMerchantId };

//# sourceMappingURL=starbucks_merchant_id.js.map